<style src="./ProductMap.scss" lang="scss" scoped></style>
<template>
  <section class="product-map">
    <div class="empty-mode" v-show="list.length === 0 && searchingMode === 0">
      <span>Listagem vazia</span>
      <icon-empty class="icon-empty"/>
    </div>

    <div class="searching-mode" v-show="searchingMode > 0">
      Pesquisando...
      <icon-wait class="icon-wait"/>
    </div>

    <div
      v-shortkey="{
        'choose-item': ['enter'],
        'go-next-item': ['arrowdown'],
        'go-prev-item': ['arrowup']}"
        @shortkey="navigateShortcut">
    </div>

    <ul v-if="searchingMode === 0">
      <li
        class="product-grid-row"
        v-for="(item, itemIdx) in list"
        :key="itemIdx"
        :class="{'focus-item': itemIdx === listStock.focusedItem}"
        @click="chooseItemByClick(item, itemIdx)"
        @contextmenu.prevent="editItem({ item, itemIdx })">

        <div class="info-1">
          <span class="pativo">{{ item.pativo }}</span>
          <span class="ncomercial">{{ item.comercialName }} ({{ item.codProd }})</span>
          <span class="lab">{{ item.lab }}</span>

          <div class="item-status">
            <span v-if="item.fisicalForm" class="fisicalType">{{ item.fisicalForm.unityType }}</span>
            <span v-show="item.isSuspended" class="suspended">SUSPENSO</span>
            <span v-show="item.isPreferred" class="preferred"><icon-star class="icon-preferred" />PREFERENCIAL</span>
          </div>
        </div>

        <div class="info-2">
          <div class="column-documents">
            <icon-anvisa-rms
              class="icon"
              v-for="(lookupAnvisa, lookupAnvisaIdx) in item.lookupAnvisa"
              :key="lookupAnvisaIdx"
              @click.stop.native="openAnvisaRms(lookupAnvisa.documentFile.fileName)" />
            
            <icon-cbpf
              v-for="(lookupCbpf, lookupCbpfIdx) in item.lookupCbpf"
              :key="lookupCbpfIdx"
              class="icon"
              @click.stop.native="openCbpf(lookupCbpf.documentFile.fileName)" />
          </div>

          <div class="commands">
            <button
              type="button"
              class="button-edit-max"
              @click.stop="editMaxPrice(item, itemIdx)"
              v-show="!item.ggremCode">
              <icon-edit class="icon"/>
              <span>EDITAR MÁXIMO</span>
            </button>
          </div>
        </div>

        <div class="info-3">
          <span class="title">CUSTO</span>
          <span class="cost"><small>R$</small>{{ (item.cost * quotedItemDetails.itemInfo.factor) | CurrencyBR }}</span>
          <div
            class="max-price icon-aside-show"
            :title="item.ggremCode"
            v-show="!!item.ggremCode">
            <small>MAX R$</small>
            <span>{{ item.lookupCmed ? item.lookupCmed.computedValue *  quotedItemDetails.itemInfo.factor : '' | CurrencyBR }}</span>
            <div class="icon-aside" @click.stop="editMaxPrice(item, itemIdx)">
              <icon-edit class="icon"/>
            </div>
          </div>

          <button
            type="button"
            class="button-edit-max"
            @click.stop="editMaxPrice(item, itemIdx)"
            v-show="!item.ggremCode">
            <icon-edit class="icon"/>
            <span>EDITAR MÁXIMO</span>
          </button>
        </div>

        <div class="info-4">
          <span class="title">ESTOQUE</span>
          <span class="stock">{{ item.stockQuantity | DecimalNumber }}</span>
          <span class="last-buy"><icon-calendar class="icon"/>{{ item.lastBuyingDate | FriendlyDate }}</span>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
import { ButtonRemove } from '@/components/primitives'
import { CurrencyBR, DecimalNumber, FriendlyDate } from '@/components/primitives/helpers/filters'
import { IconCalendar, IconAnvisaRms, IconWait, IconEmpty, IconEdit, IconCbpf, IconStar } from '@/components/primitives/icons'
import { mapGetters } from 'vuex'

export default {
  name: 'ProductMap',
  components: {
    ButtonRemove,
    IconCalendar,
    IconAnvisaRms,
    IconCbpf,
    IconWait,
    IconEmpty,
    IconEdit,
    IconStar
  },
  props: {
    list: {
      default: []
    }
  },
  data () {
    return {
      listStock: {
        focusedItem: 0
      },
      searchingMode: 0
    }
  },
  filters: {CurrencyBR, DecimalNumber, FriendlyDate},
  computed: {
    ...mapGetters({
      quotedItemDetails: 'ItemAssociation/GET_ITEM_QUOTED_DETAILS'
    })
  },
  watch: {
    list (pValue) {
      if (!pValue || (pValue && pValue.length === 0)) { this.listStock.focusedItem = 0 }
    }
  },
  methods: {
    searchSubmit () {},
    navigateShortcut (pDirection) {
      pDirection.stopPropagation()
      switch (pDirection.srcKey) {
        case 'choose-item':
          this.chooseItem()
          break
        case 'go-next-item':
          this.goToNextItem()
          break
        case 'go-prev-item':
          this.goToPrevItem()
          break
        default:
          break
      }
    },
    goToNextItem () {
      const nextIndex = this.listStock.focusedItem + 1
      if (nextIndex >= this.list.length) return false
      this.listStock.focusedItem = nextIndex
    },
    goToPrevItem () {
      const prevIndex = this.listStock.focusedItem - 1
      if (prevIndex < 0) return false
      this.listStock.focusedItem = prevIndex
    },
    chooseItem () {
      const stockId = this.list[this.listStock.focusedItem]._id
      this.itemChoosed(stockId)
    },
    openAnvisaRms (fileName) {
      const serverUrl = this.$store.getters['Login/SERVER_URL']
      window.open(`${serverUrl}/document/rms/${fileName}`)
    },
    openCbpf (fileName) {
      const serverUrl = this.$store.getters['Login/SERVER_URL']
      window.open(`${serverUrl}/document/cbpf/${fileName}`)
    },
    chooseItemByClick (pItem, pItemIdx) {
      const stockId = pItem._id
      this.listStock.focusedItem = pItemIdx
      this.itemChoosed(stockId)
    },
    itemChoosed (stockId) {
      const selectItem = !this.$store.getters['ItemAssociation/GET_CONFIG']('jumpToNextItemWhenQuote')
      this.$store.dispatch('ItemAssociation/QUOTE_ITEM', { stockId, selectItem })
      this.$emit('item-choosed')
    },
    setSearchMode (pSearchModeStatus) {
      this.searchingMode = pSearchModeStatus
    },
    editMaxPrice (pItem, pItemIdx) {
      this.$emit('edit-max-price', { item: pItem, itemIndex: pItemIdx })
    },
    editItem (item) {
      this.$emit('edit-item', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-association/components/product-map/ProductMap.vue